(function () {
  function initRoot(root) {
    if (!root || root.dataset.wicReady === "true") return;
    root.dataset.wicReady = "true";

    var rail = root.querySelector("[data-wic-rail]");
    var prev = root.querySelector("[data-wic-prev]");
    var next = root.querySelector("[data-wic-next]");
    if (!rail) return;

    function step() {
      var first = rail.querySelector(".wic__item");
      if (!first) return rail.clientWidth * 0.8;
      var styles = window.getComputedStyle(rail);
      var gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      if (!prev || !next) return;
      var maxScroll = rail.scrollWidth - rail.clientWidth - 1;
      prev.disabled = rail.scrollLeft <= 0;
      next.disabled = rail.scrollLeft >= maxScroll;
    }

    if (prev) {
      prev.addEventListener("click", function () {
        rail.scrollBy({ left: -step() });
      });
    }
    if (next) {
      next.addEventListener("click", function () {
        rail.scrollBy({ left: step() });
      });
    }

    rail.addEventListener("scroll", updateArrows, { passive: true });
    window.addEventListener("resize", updateArrows);
    updateArrows();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll("[data-wic-root]");
    Array.prototype.forEach.call(roots, initRoot);
  }

  if (document.readyState !== "loading") {
    initAll(document);
  } else {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function (e) {
      initAll(e.target);
    });
  }
})();
